export type EmbeddedOAuthSenderKind =
  | 'iframe_child'
  | 'iframe_parent'
  | 'null'
  | 'opener'
  | 'other_window'
  | 'self'
  | 'tracked_popup';

export const classifyEmbeddedOAuthSender = (
  source: MessageEventSource | null,
  isTrackedPopup: boolean,
  currentWindow: Window = window
): EmbeddedOAuthSenderKind => {
  if (!source) return 'null';
  if (source === currentWindow) return 'self';
  if (isTrackedPopup) return 'tracked_popup';

  try {
    if (currentWindow.opener && source === currentWindow.opener) return 'opener';
    if (currentWindow.parent !== currentWindow && source === currentWindow.parent) return 'iframe_parent';
    if (
      Array.from({ length: currentWindow.frames.length }, (_, index) => currentWindow.frames[index]).some(
        (frame) => frame === source
      )
    ) {
      return 'iframe_child';
    }
  } catch {
    // A cross-origin window lookup must not interrupt login.
  }
  return 'other_window';
};
